import React from "react";
import { Container } from "./styled";

const SuccessPopUp = () => {
  return (
    <Container id="SuccessPopUp">
      <h1>Guardado!!!</h1>
    </Container>
  );
};

export default SuccessPopUp;
